(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["dropin-blog-home-section"] && !window.DesignMode) return;
  try {
    
  callDropInBlogHomePage()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact-template"]) return;
  try {
    
$('#location-dropdown').trigger('change');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url + '?section_id=product-recommendations&limit=' + limit + '&product_id=' + productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
      theme.initUniformHeightMonitor(productRecommendationsSection, '.product-block__image-container', '.product-block__image-container .image-one');
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    theme.destroyUniformHeightMonitor($('.product-recommendations', event.target));
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-locations"]) return;
  try {
    
  $('#location-dropdown').trigger('change');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yk-dropin-blog-section"]) return;
  try {
    
    callDropInBlogForBanner();
    callDropInBlogReleaseMonth();

  } catch(e) { console.error(e); }
})();

})();
